<template>
  <div
    class="status-card"
  >
    <div
      class="status-card__logo"
      :class="statusLogoClass"
    >
      <svg
        width="34"
        height="36"
        viewBox="0 0 34 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33.4387 36H25.1795L19.1062 22.8033C17.2461 23.8152 15.8339 25.5703 14.3593 27.403C13.2056 28.837 12.0136 30.3185 10.5389 31.5287C8.82254 32.9364 6.82743 34.1829 4.33354 35.0335C3.20396 35.4147 1.2822 35.9133 0.563371 35.9867C0.255303 36.016 0.0499238 36.0013 0.00591405 35.8987C-0.0234258 35.8107 0.0499238 35.752 0.372662 35.5907C0.437927 35.5594 0.539429 35.5137 0.667577 35.456C1.25963 35.1893 2.42023 34.6666 3.20396 34.1243C4.39222 33.2884 5.06704 32.3939 5.12572 31.7046C5.06583 31.4924 4.93674 31.2317 4.78138 30.9179C4.09948 29.5406 2.91145 27.1411 4.84699 23.3312C5.18897 22.6534 5.51199 22.0537 5.81034 21.4999C6.25429 20.6758 6.64361 19.9531 6.95946 19.2251C7.56093 17.832 8.00102 15.867 8.14772 14.4005C8.16239 14.3125 8.17706 14.3125 8.22107 14.3712C9.38 15.5444 13.869 20.149 13.2088 24.739C14.7052 24.1671 17.2871 22.422 18.4754 21.4981C18.7546 21.2807 19.0122 21.0618 19.2586 20.8525C20.1257 20.1159 20.8539 19.4973 21.8934 19.4744C22.5612 19.4662 22.8862 19.6432 23.2119 19.8207C23.4659 19.959 23.7203 20.0976 24.1379 20.149C24.3727 20.1783 24.7247 20.1343 24.9008 20.0464C24.9741 20.017 24.9595 19.929 24.8421 19.8997C24.3049 19.7716 23.9354 19.514 23.5665 19.2568C23.0489 18.8959 22.5325 18.5359 21.556 18.5359C20.4302 18.5359 19.4705 19.3162 18.6956 19.9462C18.4406 20.1536 18.2056 20.3447 17.9912 20.4863L13.7516 11.6583C11.9912 7.96282 12.5194 5.27922 16.4216 0L33.4387 36Z"
          fill="white"
        />
      </svg>
    </div>
    <div
      class="status-card__info"
    >
      <dl
        v-if="status"
        class="status-card__list"
      >
        <dt class="status-card__item-label">
          {{ statusLabel }}
        </dt>
        <dd class="status-card__item-val">
          {{ status }}
        </dd>
      </dl>
      <dl
        v-if="endDate && endDateFormat"
        class="status-card__list"
      >
        <dt class="status-card__item-label status-card__list-label--date">
          {{ endDateLabel }}
        </dt>
        <dd class="status-card__item-val status-card__list-val--date">
          {{ endDateFormat }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script lang="es" src="./StatusCard.es"></script>
<style lang="scss" src='./StatusCard.scss' scoped></style>
